import DOMPurify from 'dompurify';
import moment from 'moment';
import { useState, useEffect } from 'react';


const DropDownList = ({item, index, curIndex, setCurIndex, currentTab, page}) => {

  const sanitizer = DOMPurify.sanitize;

  const [state, setState] = useState(false)

  useEffect(() => {
    setState(true)
  }, [curIndex])

  useEffect(() => {
    setState(false)
  }, [currentTab])

  return (
    <li className={state && curIndex === index ? 'active' : ''}>
      <button type="button" onClick={() => {setState(!state); setCurIndex(index)}}>
        <i className={`icofont-rounded-right`}></i>
        <span className="listTit">{item[`${page}_title`]}</span>
        <span className="listDate">{moment(item[`${page}_create_date`]).format('YYYY.MM.DD')}</span>
      </button>

      <div className="listCont" dangerouslySetInnerHTML={{ __html: sanitizer(item[`${page}_content`])}}></div>
    </li>
  )
}

export default DropDownList